"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleChannelSearchTabsApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function appleChannelSearchTabsApiClient(networkClient) {
    return {
        findSearchTabsOptions: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/options/search-tabs`);
        },
        getAstChannel: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs`);
        },
        createAstChannel: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs`, body);
        },
        updateAstChannel: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs`, body);
        },
        deleteAstChannel: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs`);
        },
        listAstChannels: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/search-tabs`, query, config);
        },
        getAstChannelRegion: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/regions/${params.regionId}`);
        },
        listAstChannelRegions: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/regions`, query, config);
        },
        createAstChannelRegion: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/regions`, body);
        },
        updateAstChannelRegion: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/regions/${params.regionId}`, body);
        },
        deleteAstChannelRegion: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/regions/${params.regionId}`);
        },
        getAstChannelSynchronisation: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/synchronisation`);
        },
        importAstCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/import`, body);
        },
        updateAstCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/update-import`, body);
        },
        syncAstChannel: async (params, body = {}) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/sync`, body);
        },
        listAstChannelCampaignNames: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/campaign-names`, query, config);
        },
        updateAstChannelCampaignNames: async (params, body) => {
            return networkClient.putHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/search-tabs/campaign-names`, body);
        },
    };
}
exports.appleChannelSearchTabsApiClient = appleChannelSearchTabsApiClient;
